import styled from 'styled-components';
import { Alert } from '../../fuse-alert/src/alert';
import { gridConfig as breakpoints } from '../../fuse-responsive-grid/src/grid';
import { TypographyComponent } from '../../fuse-typography-element/src/typography';

const StyledRadioGroup = styled.fieldset.attrs({
	className: 'fuse-radio-group',
})`
	width: 100%;
`;

const StyledRadioLegend = styled(TypographyComponent).attrs({
	className: 'fuse-radio-group__legend',
	'data-testid': 'fuse-radio-group__legend',
})`
	margin-bottom: var(--spacing-global-space6);
`;

const StyledRadioAlert = styled(Alert).attrs({
	className: 'fuse-radio-group__alert',
	'data-testid': 'fuse-radio-group__alert',
})`
	display: flex;
	margin-bottom: var(--spacing-global-space6);
	width: 100%;

	@media only screen and (min-width: ${breakpoints.m.minWidth}) {
		width: fit-content;
	}
`;

const StyledRadioContainer = styled.div.attrs({
	className: 'fuse-radio-group__radio-container',
	'data-testid': 'fuse-radio-group__radio-container',
})`
	${({ stacked }) => `
		display: flex;
		flex-flow: ${stacked ? 'column' : 'row'} wrap;
		
		& .fuse-radio {
			margin-bottom: var(--spacing-global-space6);
			margin-right: ${stacked ? `0` : `var(--spacing-global-space6)`};
		}
	`}
`;

export { StyledRadioAlert, StyledRadioContainer, StyledRadioGroup, StyledRadioLegend };
